import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { InfoModal } from 'shared/components/ui/info-modal/info-modal';
import { useAccount } from 'shared/hooks/use-web3';
import { usePlayerGamesStore } from 'shared/store/playerGamesStore';

import { InputHash } from './InputHash';

interface IHashProps {
  setIsShow: (value: boolean) => void;
}

export const Hash = forwardRef<HTMLDivElement, IHashProps>(({ setIsShow }) => {
  const { mainSalt } = usePlayerGamesStore();
  const { address, chainId } = useAccount();
  const { activeRoomId } = useParams();
  const { t } = useTranslation();
  return (
    <InfoModal onClose={() => setIsShow(false)} title={t('common.attention')}>
      <p className="relative mb-4 self-stretch text-center text-md font-normal leading-5 text-white/80 md:mb-6 md:text-sm">
        {t('hash.interrupted')}
      </p>
      <p className="relative mb-4 self-stretch text-center text-md font-normal leading-5 text-white/80 md:mb-6 md:text-sm">
        {t('hash.need')}
      </p>
      <InputHash
        className="mx-auto w-[90%] hd:mb-2"
        value={mainSalt[activeRoomId! + address! + chainId] ?? ''}
        copy={!!mainSalt[activeRoomId! + address! + chainId]}
      />
    </InfoModal>
  );
});
